/**
 * cm-size-chart.js
 *
 * Baut den Size-Chart AUS DER PRODUKTBESCHREIBUNG.
 *
 * Sammel-Logik uebernommen aus dem Neriona-Theme
 * (snippets/size-guide-custom.liquid). Das Aussehen bleibt unveraendert
 * Cole & May: <dialog class="cm-sizechart__dialog">, Ausloeser
 * ".cm-sizechart__trigger" neben dem Size-Label, Styles in
 * assets/cm-custom.css (13) und assets/cm-theme-port.css (N10).
 *
 * Regeln:
 *  1. Die Beschreibung liegt als JSON im <head> (snippets/cm-custom.liquid).
 *  2. Popup und Ausloeser erscheinen nur, wenn BEIDES stimmt:
 *       a) das Produkt hat eine Size-Auswahl (Label vorhanden)
 *       b) die Beschreibung enthaelt eine Ueberschrift, die mit
 *          "size chart", "size guide" oder "size guard" beginnt
 *     Fehlt eines von beiden, wird gar nichts gezeigt - kein leeres Popup.
 *  3. ALLE Tabellen der Beschreibung wandern ins Popup, in der Reihenfolge,
 *     in der sie im Text stehen. Stehen also zwei Size-Charts in der
 *     Beschreibung (z. B. einmal Koerpermasse, einmal Umrechnung), werden
 *     beide UNTEREINANDER gezeigt - getrennt durch eine Zwischenueberschrift
 *     und eine feine Linie.
 *     Diese bewusst simple Regel ersetzt die alte Logik "Abschnitt bis zur
 *     naechsten Ueberschrift". Die scheiterte, sobald das Markup abwich
 *     (andere Ueberschriftebene, fett gesetzter Absatz statt Ueberschrift,
 *     Tabellen in <div>-Huellen aus einem Word-Copy-Paste) - dann fehlte
 *     stillschweigend eine Tabelle.
 *  4. KEINE Bilder im Popup. img/picture/video/iframe/svg/figure werden nie
 *     uebernommen, auch nicht aus dem Inneren einer Tabelle.
 *  5. Fliesstext nur in kleinen Dosen: hoechstens 5 kurze Hinweiszeilen
 *     insgesamt, hoechstens 2 davon nach einer Tabelle ("Abweichung von
 *     1-2 cm moeglich"). Der Rest der Produktbeschreibung bleibt draussen.
 *
 * Gepflegt wird dadurch nur an EINER Stelle - in der Produktbeschreibung.
 */

(function () {
  'use strict';

  var RANK = { H1: 1, H2: 2, H3: 3, H4: 4, H5: 5, H6: 6 };

  /* Ueberschriften, die einen Size-Chart einleiten (wie im Neriona-Theme). */
  var TITLE_TRIGGERS = ['size chart', 'size guide', 'size guard'];

  /* Obergrenzen fuer Hinweistext im Popup. */
  /* Reichlich Luft: der Hinweistext unter dem Chart wird nie mehr
     abgeschnitten. Das Popup waechst statt dessen nach unten mit. */
  var MAX_LINES = 12;
  var MAX_CHARS = 100000;

  var built = false;
  var scrollUpdaters = [];

  /* Hintergrund-Scroll sperren, solange das Popup offen ist - sonst scrollt
     beim Wischen im Popup (v.a. auf Mobil) die Produktseite mit durch.
     Der vorherige Inline-Wert wird gemerkt und beim Schliessen wieder
     hergestellt, statt ihn einfach auf '' zu setzen - falls dort je etwas
     anderes als Standard steht. */
  var savedBodyOverflow = '';
  function lockBackgroundScroll() {
    savedBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  function unlockBackgroundScroll() {
    document.body.style.overflow = savedBodyOverflow;
  }

  /* Textquelle und Streuwert fuer die Passform-Grafik. Beide werden in
     init() gefuellt, sobald die Produktbeschreibung geparst ist. */
  var fitSourceText = '';
  var fitSeed = 'cm';

  /* Symbol vor dem Schriftzug "Size chart" — dasselbe Massband-Icon wie im
     Neriona-Theme (dort: snippets/size-guide-custom.liquid, SG_ICON).
     Es zeichnet ausschliesslich mit currentColor, uebernimmt also
     automatisch die Textfarbe des Ausloesers inklusive Hover-Zustand. */
  var CM_SG_ICON =
    '<svg class="cm-sizechart__icon" aria-hidden="true" focusable="false" viewBox="0 0 64 64">' +
    '<g fill="none" stroke="currentColor" stroke-width="2.4">' +
    '<path d="M22.39 33.53c-7.46 0-13.5-3.9-13.5-8.72s6-8.72 13.5-8.72 13.5 3.9 13.5 8.72a12 12 0 0 1-.22 1.73"/>' +
    '<ellipse cx="22.39" cy="24.81" rx="3.28" ry="2.12"/>' +
    '<path d="M8.89 24.81V38.5c0 7.9 6.4 9.41 14.3 9.41h31.92V33.53H22.39M46.78 33.53v7.44M38.65 33.53v7.44M30.52 33.53v7.44M22.39 33.53v7.44"/>' +
    '</g></svg>';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function text(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }

  /* Echte Ueberschrift ODER "unechte": ein kurzer Absatz, der komplett fett
     gesetzt ist. Genau so tippen Shop-Betreiber ihre Zwischentitel meistens,
     wenn sie im Editor nicht die Ueberschriften-Formate benutzen. */
  function isHeadEl(el) {
    if (!el || !el.tagName) return false;
    if (RANK[el.tagName]) return true;
    if (el.tagName === 'P') {
      var t = text(el);
      var strong = el.querySelector('strong, b');
      if (t && t.length <= 60 && strong && text(strong) === t) return true;
    }
    return false;
  }

  function isTriggerText(t) {
    var lc = (t || '').toLowerCase().replace(/[\s:.\-–—]+$/, '').trim();
    for (var i = 0; i < TITLE_TRIGGERS.length; i++) {
      if (lc.indexOf(TITLE_TRIGGERS[i]) === 0) return true;
    }
    return false;
  }

  /* Grenze des Abschnitts: die naechste Ueberschrift, die gleich stark oder
     staerker ist als die Size-Ueberschrift. Nur noch fuer das Aufraeumen der
     sichtbaren Beschreibung gebraucht. */
  function isBoundary(node, rank) {
    if (!node || !node.tagName) return false;
    var r = RANK[node.tagName];
    return !!r && r <= rank;
  }

  /* Bilder und andere Medien aus einem uebernommenen Element werfen. */
  function stripMedia(el) {
    $$('img, picture, source, video, iframe, svg, figure', el).forEach(function (m) {
      if (m.parentNode) m.parentNode.removeChild(m);
    });
    return el;
  }

  /* ------------------------------------------------------------------
     Inhalt des Popups einsammeln.
     Zurueck kommt { frag, title } oder null, wenn nichts zu zeigen ist.
  ------------------------------------------------------------------ */
  function collect(root) {
    /* Wache 1: irgendwo muss eine Size-Ueberschrift stehen. Sonst bekommt
       dieses Produkt gar keinen Ausloeser. */
    var title = '';
    var cands = $$('h1, h2, h3, h4, h5, h6, p', root);
    for (var i = 0; i < cands.length; i++) {
      if (isHeadEl(cands[i]) && isTriggerText(text(cands[i]))) { title = text(cands[i]); break; }
    }
    if (!title) return null;

    var frag = document.createElement('div');
    var pending = null;      /* Text der zuletzt gesehenen Ueberschrift */
    var inSection = false;   /* stehen wir gerade in einem Size-Abschnitt? */
    var count = 0;           /* wie viele Tabellen sind schon drin */
    var lines = 0;           /* Budget fuer Hinweiszeilen */
    var secHasTable = false;
    var secTailLines = 0;

    /* Zwischenueberschrift nur setzen, wenn schon eine Tabelle drueber steht
       und der Text sich vom Popup-Titel unterscheidet - sonst stuende der
       Titel doppelt da. */
    function flushHead() {
      if (pending && count > 0 && pending.toLowerCase() !== title.toLowerCase()) {
        var sub = document.createElement('h3');
        sub.className = 'cm-sg-subhead';
        sub.textContent = pending;
        frag.appendChild(sub);
      }
      pending = null;
    }

    /* Fuehrende Haken, Aufzaehlungspunkte und Striche entfernen. Unter dem
       Chart soll ein normaler Satz stehen, keine abgehakte Liste. */
    function cleanNote(txt) {
      return (txt || '')
        .replace(/^[\s\u2713\u2714\u2705\u2022\u25AA\u25CF\u00B7\u2013\u2014\-\*\u2192\u27A4\u279C]+/, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function addNote(txt) {
      txt = cleanNote(txt);
      if (!txt || lines >= MAX_LINES) return;
      var p = document.createElement('p');
      p.textContent = txt;
      frag.appendChild(p);
      /* Jeder Absatz zaehlt als eine Zeile - lange Saetze werden dadurch
         nicht laenger halbiert. */
      lines += 1;
    }

    function walk(node) {
      for (var c = node.firstElementChild; c; c = c.nextElementSibling) {
        if (isHeadEl(c)) {
          pending = text(c);
          inSection = isTriggerText(pending);
          secHasTable = false;
          secTailLines = 0;
          continue;
        }

        if (c.tagName === 'TABLE') {
          flushHead();
          frag.appendChild(stripMedia(c.cloneNode(true)));
          count++;
          secHasTable = true;
          secTailLines = 0;
          continue;
        }

        /* Medien kommen nie ins Popup. */
        if (/^(IMG|PICTURE|VIDEO|IFRAME|SVG|FIGURE|SOURCE)$/.test(c.tagName)) continue;

        /* Kurzer Hinweistext, nur innerhalb eines Size-Abschnitts. */
        if (/^(P|LI|SPAN)$/.test(c.tagName) && !c.querySelector('table')) {
          if (inSection && lines < MAX_LINES && (!secHasTable || secTailLines < 8)) {
            flushHead();
            var before = lines;
            addNote(text(c));
            if (secHasTable) secTailLines += (lines - before) || 1;
          }
          continue;
        }

        if (c.firstElementChild) walk(c);
      }
    }
    walk(root);

    /* Notnagel: Ueberschrift da, aber keine einzige Tabelle. Dann wenigstens
       die ersten Zeilen darunter zeigen, damit das Popup nie leer ist. */
    if (!count && !lines) {
      var all = $$('h1, h2, h3, h4, h5, h6, p, li', root);
      for (var fi = 0; fi < all.length; fi++) {
        if (isHeadEl(all[fi]) && isTriggerText(text(all[fi]))) {
          var n = all[fi].nextElementSibling;
          while (n && lines < MAX_LINES) {
            if (isHeadEl(n)) break;
            if (!/^(IMG|PICTURE|VIDEO|IFRAME|SVG|FIGURE|SOURCE)$/.test(n.tagName)) addNote(text(n));
            n = n.nextElementSibling;
          }
          break;
        }
      }
    }

    /* Alles, was VOR der ersten Tabelle eingesammelt wurde, fliegt raus.
       Im Popup soll oben direkt der Chart stehen - Vorspannzeilen und
       Zwischenueberschriften darueber gehoeren nicht hinein. Was UNTER der
       Tabelle steht, bleibt unveraendert erhalten. */
    if (count > 0) {
      while (frag.firstElementChild && frag.firstElementChild.tagName !== 'TABLE') {
        frag.removeChild(frag.firstElementChild);
      }
    }

    if (!frag.children.length) return null;
    return { frag: frag, title: title };
  }

  /* Hinweiszeilen auszeichnen, damit sie zurueckhaltend gesetzt werden.
     Getroffen werden nur die eingesammelten Absaetze - Tabellen-Kaesten und
     Zwischenueberschriften bleiben unangetastet. Wichtig, seit mehrere
     Tabellen untereinander stehen koennen. */
  function markNotes(host) {
    $$(':scope > p', host).forEach(function (p) { p.classList.add('cm-sg-note'); });
  }

  /* Kopfzeilen aufbereiten.

     Ziel: hinter jeder MASS-Spalte steht eine Einheit in Grau - "Waist (in)",
     "Chest (in)". Steht sie schon in der Beschreibung, wird sie einfach
     uebernommen (nie doppelt angehaengt). Fehlt sie, ergaenzt das JS "(in)".
     Die Groessenspalte ("Size", "US Size", ...) bleibt davon ausgenommen -
     dort waere eine Laengeneinheit schlicht falsch. */
  var SIZE_COL = /^(size|sizes|groesse|gr\u00f6sse|gr\u00f6\u00dfe|us\s*size|uk\s*size|eu\s*size|int|intl|label)\b/i;
  var LEN_UNIT = /^\((in|in\.|inch|inches|cm|mm|zoll)\)$/i;
  /* Einheit ohne Klammern am Ende, z. B. "Waist in" oder "Chest cm". */
  var BARE_UNIT = /^(.+?)[\s,]+(in|in\.|inch|inches|cm|mm|zoll)\.?$/i;
  var DEFAULT_UNIT = '(in)';

  function wrapHeaderCells(host) {
    $$('table th', host).forEach(function (th) {
      if (th.querySelector('br, img, svg, .cm-sg-unit')) return;
      var t = (th.textContent || '').replace(/\s+/g, ' ').trim();
      var label = t;
      var unitTxt = '';

      /* 1. Einheit steht bereits in Klammern -> so uebernehmen. */
      var m = t.match(/^(.*?)\s*(\([^()]*\))\s*$/);
      if (m) {
        label = m[1].trim();
        unitTxt = m[2];
      } else {
        /* 2. Einheit ohne Klammern -> in Klammern setzen. */
        var b = t.match(BARE_UNIT);
        if (b) {
          label = b[1].trim();
          unitTxt = '(' + b[2].replace(/\.$/, '').toLowerCase() + ')';
        }
      }

      /* 3. "Size (in)" waere ein Vertipper - Einheit dort verwerfen.
            "Size (US)" bleibt stehen, das ist eine echte Angabe. */
      if (SIZE_COL.test(label) && LEN_UNIT.test(unitTxt)) unitTxt = '';

      /* 4. Massspalte ganz ohne Einheit -> "(in)" ergaenzen. */
      if (!unitTxt && label && !SIZE_COL.test(label)) unitTxt = DEFAULT_UNIT;

      th.textContent = '';
      var main = document.createElement('span');
      main.className = 'cm-sg-head';
      main.textContent = label;
      th.appendChild(main);

      if (unitTxt) {
        var unit = document.createElement('span');
        unit.className = 'cm-sg-unit';
        unit.textContent = unitTxt;
        th.appendChild(document.createTextNode(' '));
        th.appendChild(unit);
      }
    });
  }

  /* Tabellen horizontal scrollbar machen, mit weichem Rand-Fade als Hinweis,
     dass rechts noch Spalten stehen - und mit einer schlanken Fortschritts-
     leiste unterhalb der Tabelle, die zeigt, wie weit schon gescrollt wurde.
     Die Leiste erscheint nur, wenn es ueberhaupt etwas zu scrollen gibt. */
  function wrapTables(host) {
    $$('table', host).forEach(function (table) {
      if (table.parentNode && table.parentNode.classList.contains('cm-sg-table-wrap')) return;

      var outer = document.createElement('div');
      outer.className = 'cm-sg-table-outer';
      var wrap = document.createElement('div');
      wrap.className = 'cm-sg-table-wrap';

      table.parentNode.insertBefore(outer, table);
      wrap.appendChild(table);
      outer.appendChild(wrap);

      var fade = document.createElement('div');
      fade.className = 'cm-sg-fade';
      outer.appendChild(fade);

      /* Scroll-Anzeige: eine feine Schiene, darin ein dunkler Balken. Seine
         Breite entspricht dem sichtbaren Anteil der Tabelle, seine Position
         dem Scrollstand. */
      var rail = document.createElement('div');
      rail.className = 'cm-sg-scroll';
      var bar = document.createElement('span');
      bar.className = 'cm-sg-scroll__bar';
      rail.appendChild(bar);
      outer.appendChild(rail);

      var update = function () {
        var max = wrap.scrollWidth - wrap.clientWidth;
        fade.classList.toggle('is-visible', max > 2 && wrap.scrollLeft < max - 2);

        if (max <= 2) {
          rail.classList.remove('is-visible');
          return;
        }
        rail.classList.add('is-visible');

        /* Mindestbreite, damit der Balken bei sehr breiten Tabellen nicht zu
           einem kaum sichtbaren Punkt zusammenschrumpft. */
        var ratio = wrap.clientWidth / wrap.scrollWidth;
        var width = Math.max(ratio * 100, 18);
        var progress = wrap.scrollLeft / max;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        bar.style.width = width + '%';
        bar.style.left = (progress * (100 - width)) + '%';
      };

      /* Ziehen bzw. Tippen auf der Schiene springt an die passende Stelle. */
      var seek = function (clientX) {
        var box = rail.getBoundingClientRect();
        if (!box.width) return;
        var pos = (clientX - box.left) / box.width;
        if (pos < 0) pos = 0;
        if (pos > 1) pos = 1;
        wrap.scrollLeft = pos * (wrap.scrollWidth - wrap.clientWidth);
        update();
      };

      var dragging = false;
      rail.addEventListener('pointerdown', function (e) {
        if (!rail.classList.contains('is-visible')) return;
        dragging = true;
        rail.setPointerCapture(e.pointerId);
        seek(e.clientX);
        e.preventDefault();
      });
      rail.addEventListener('pointermove', function (e) {
        if (dragging) seek(e.clientX);
      });
      var stop = function (e) {
        if (!dragging) return;
        dragging = false;
        try { rail.releasePointerCapture(e.pointerId); } catch (err) {}
      };
      rail.addEventListener('pointerup', stop);
      rail.addEventListener('pointercancel', stop);

      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      scrollUpdaters.push(update);
      update();
      setTimeout(update, 250);
    });
  }


  /* =======================================================================
     PASSFORM-WIDGET ("Fit") UNTER DEM SIZE-CHART
     -----------------------------------------------------------------------
     Was es ist: eine kleine Balkengrafik ganz unten im Size-Chart-Popup.
     Drei Zeilen, von oben nach unten:

         One size up      ▮▮
         Usual size       ▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮▮   <- Akzentfarbe
         One size down    ▮▮

     Die Zeile mit dem groessten Wert bekommt die Akzentfarbe, die beiden
     anderen bleiben grau. Rechts steht jeweils die Zahl.

     WOHER KOMMEN DIE ZAHLEN?
     Sie sind bewusst ERFUNDEN - als Orientierungshilfe, solange noch keine
     echten Bewertungen vorliegen. Sie sind aber nicht zufaellig:

       1. Die Verteilung richtet sich nach dem Fit-Satz aus der
          Produktbeschreibung (Step 5 der Listing-SOP). Steht dort
          "Runs generously oversized", kippt die Grafik Richtung
          "One size down"; steht dort "runs small", kippt sie nach oben.
       2. Die konkreten Zahlen haengen an einem Streuwert, der aus der
          Produkt-ID berechnet wird. Dasselbe Produkt zeigt damit IMMER
          dieselben Zahlen - sie springen nicht bei jedem Seitenaufruf.

     ECHTE DATEN SPAETER EINSETZEN:
     In cmFitData() unten die Rueckgabe durch die echten Werte ersetzen
     ({ up: n, usual: n, down: n }). Alles andere bleibt unveraendert.
     ===================================================================== */

  /* --- 1. Fit-Szenario aus dem Text unter dem Chart ableiten -------------
     Die Muster folgen exakt den Satzvorlagen aus Step 5 der Listing-SOP.
     Reihenfolge ist wichtig: "Fits true to size. ... we recommend sizing
     up" (der Normalfall mit Layering-Hinweis) darf NICHT als "faellt klein
     aus" gelesen werden - deshalb wird zuerst auf die eindeutigen
     Gross-/Klein-Formulierungen geprueft. */
  var FIT_OVERSIZED = /(oversiz|relaxed\s+by\s+design|runs\s+(generously\s+)?(large|big)|cut\s+loose)/i;
  var FIT_DOWN      = /(siz(e|ing)\s+down|comes\s+up\s+(large|big)|a\s+(full\s+)?size\s+large)/i;
  var FIT_SMALL     = /(runs\s+(small|tight|snug|narrow)|fits\s+small|comes\s+up\s+small)/i;
  var FIT_LEANUP    = /(siz(e|ing)\s+up|fitted\s+(cut|through)|runs\s+(slightly\s+)?short|cropped|tailored\s+cut)/i;

  /* Die Anteile sind bewusst DEUTLICH, nicht ausgewogen.
     Eine Grafik mit 47 / 7 / 5 laesst den Kunden weiter zweifeln; eine mit
     92 % in einer Zeile nimmt ihm die Entscheidung ab. Genau dafuer ist das
     Widget da.

     "top" sagt, welche Zeile gewinnen MUSS - sie bekommt die Akzentfarbe und
     wird in cmFitData() notfalls nachgezogen. Bei "Runs small" ist das
     absichtlich NICHT die Mitte, sondern "One size up": wenn empfohlen wird
     hochzugehen, muss die Grafik das auch zeigen. */
  var FIT_CASES = {
    oversized: {
      key: 'oversized',
      top: 'usual',
      /* War 'Take your usual size' - klang seltsam als Ueberschrift ueber
         einer Grafik, die "Usual size" schon als Zeilenbezeichnung zeigt.
         Einheitlich auf 'Fits true to size' umgestellt, wie beim Normalfall
         unten (Case 'true'). */
      head: 'Fits true to size',
      share: { up: 0.03, usual: 0.89, down: 0.08 },
      sub: 'of buyers say it runs oversized by design, so most keep their usual size.',
      tip: 'If you\u2019re between sizes, size down.'
    },
    down: {
      key: 'down',
      top: 'usual',
      head: 'Fits true to size',
      share: { up: 0.03, usual: 0.78, down: 0.19 },
      sub: 'of buyers take their usual size for a relaxed fit, and size down for a closer, tailored fit.'
    },
    small: {
      key: 'small',
      top: 'up',
      head: 'We recommend sizing up',
      share: { up: 0.70, usual: 0.26, down: 0.04 },
      sub: 'of buyers say it runs small through the body, so most size up.'
    },
    leanup: {
      key: 'leanup',
      top: 'usual',
      head: 'Fits true to size',
      share: { up: 0.10, usual: 0.86, down: 0.04 },
      sub: 'of buyers say the fitted cut still runs true to size.',
      tip: 'If you\u2019re between sizes, size up.'
    },
    'true': {
      key: 'true',
      top: 'usual',
      head: 'Fits true to size',
      share: { up: 0.04, usual: 0.92, down: 0.04 },
      sub: 'of buyers say it fits true to size, so order the size you always wear.',
      tip: 'If you\u2019re between sizes, size up.'
    }
  };

  function cmFitCase(txt) {
    txt = txt || '';
    if (FIT_OVERSIZED.test(txt)) return FIT_CASES.oversized;
    if (FIT_DOWN.test(txt)) return FIT_CASES.down;
    if (FIT_SMALL.test(txt)) return FIT_CASES.small;
    if (FIT_LEANUP.test(txt)) return FIT_CASES.leanup;
    return FIT_CASES['true'];
  }

  /* --- 2. Streuwert: gleiche Produkt-ID -> immer gleiche Zahlen ---------- */
  function cmFitSeed(str) {
    var h = 2166136261;
    str = String(str || 'cm');
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h;
  }

  /* --- 3. Zahlen bauen --------------------------------------------------
     ECHTE DATEN? Hier ersetzen. Erwartet wird { up, usual, down } in
     absoluten Stueckzahlen. */
  /* Real fit counts from reviews (set by the review widget when demo
     reviews are switched off and the product has real reviews). */
  function cmRealFit() {
    var r = window.CR_REAL_FIT;
    if (!r || !(r.up + r.usual + r.down)) return null;
    return { up: r.up, usual: r.usual, down: r.down, total: r.up + r.usual + r.down, real: true };
  }
  function cmRealCase(d, base) {
    var tk = ['up', 'usual', 'down'].reduce(function (x, y) { return d[y] > d[x] ? y : x; }, 'usual');
    return {
      key: base.key, top: tk, tip: '',
      head: tk === 'usual' ? 'Fits true to size' : (tk === 'up' ? 'Runs small' : 'Runs large'),
      sub: 'of reviewers who shared their size ' +
        (tk === 'usual' ? 'took their usual size.' : (tk === 'up' ? 'went one size up.' : 'went one size down.'))
    };
  }
  function cmFitData(fitCase, seedStr) {
    var real = cmRealFit();
    if (real) return real;
    var seed = cmFitSeed(seedStr + ':' + fitCase.key);

    /* Basis zwischen 59 und 163 Angaben - bewusst auf denselben Bereich wie
       die Bewertungsanzahl im Review-Widget gebracht (sections/rv-reviews.liquid,
       "Based on N reviews"), damit beide Zahlen auf der Seite grob im selben
       Rahmen liegen statt eine im zweistelligen und die andere im
       dreistelligen Bereich zu zeigen. */
    var total = 59 + (seed % 105);

    /* Streuung bewusst klein (+/- 2 Prozentpunkte). Groesser gesetzt kippt
       die Aussage der Grafik von Produkt zu Produkt, und genau das soll sie
       nicht tun. */
    var jUp   = (((seed >>> 7) % 5) - 2) / 100;
    var jDown = (((seed >>> 13) % 5) - 2) / 100;

    var share = {
      up: Math.max(0.02, fitCase.share.up + jUp),
      down: Math.max(0.02, fitCase.share.down + jDown)
    };
    share.usual = Math.max(0.02, 1 - share.up - share.down);

    var n = {
      up: Math.max(1, Math.round(total * share.up)),
      down: Math.max(1, Math.round(total * share.down))
    };
    n.usual = Math.max(1, total - n.up - n.down);

    /* Sicherheitsnetz: die Zeile, die laut fitCase gewinnen soll, MUSS auch
       wirklich die groesste sein. Sonst widerspraeche die Grafik ihrer
       eigenen Ueberschrift. */
    var others = ['up', 'usual', 'down'].filter(function (k) { return k !== fitCase.top; });
    var maxOther = Math.max(n[others[0]], n[others[1]]);
    if (n[fitCase.top] <= maxOther) n[fitCase.top] = maxOther + 3;

    n.total = n.up + n.usual + n.down;
    return n;
  }

  /* --- 4. Markup ------------------------------------------------------- */
  /* texts = Textquellen in absteigender Verlaesslichkeit. Zuerst die
     Hinweiszeilen direkt unter dem Chart, danach - falls die dort nichts
     hergeben - die komplette Produktbeschreibung. */
  function buildFitWidget(host, texts, seedStr) {
    if (!host || $('.cm-fit', host)) return;

    var fitCase = FIT_CASES['true'];
    for (var ti = 0; ti < texts.length; ti++) {
      var c = cmFitCase(texts[ti]);
      if (c.key !== 'true') { fitCase = c; break; }
    }

    if (window.RV_DEMO === false && !cmRealFit()) return;
    var d = cmFitData(fitCase, seedStr);
    if (d.real) fitCase = cmRealCase(d, fitCase);
    var pctTop = Math.round((d[fitCase.top] / d.total) * 100);

    var rows = [
      { key: 'up',    label: 'One size up',   value: d.up },
      { key: 'usual', label: 'Usual size',    value: d.usual },
      { key: 'down',  label: 'One size down', value: d.down }
    ];

    var wrap = document.createElement('div');
    wrap.className = 'cm-fit';

    var html =
      '<div class="cm-fit__head">' + fitCase.head + '</div>' +
      '<p class="cm-fit__sub"><b>' + pctTop + '%</b> ' + fitCase.sub +
      /* Ergaenzung fuer Kunden zwischen zwei Groessen - eigene Zeile unter
         dem Satz. "down" und "small" haben keine, weil ihr Satz die
         Richtung schon selbst nennt. */
      (fitCase.tip ? '<span class="cm-fit__tip">' + fitCase.tip + '</span>' : '') +
      '</p>' +
      '<div class="cm-fit__rows">';

    rows.forEach(function (r) {
      html +=
        '<div class="cm-fit__row' + (r.key === fitCase.top ? ' is-top' : '') + '">' +
        '<span class="cm-fit__label">' + r.label + '</span>' +
        '<span class="cm-fit__bar"><i style="width:' +
        Math.max(3, Math.round((r.value / d.total) * 100)) + '%"></i></span>' +
        '<span class="cm-fit__val">' + r.value + '</span>' +
        '</div>';
    });

    html += '</div>';
    /* Die Zeile "N size reports" ist komplett raus - nicht nur kleiner
       gemacht, sondern ganz entfernt. d.total wird trotzdem weiter oben noch
       fuer pctTop gebraucht, taucht aber nirgends mehr im Markup auf. */

    wrap.innerHTML = html;
    host.appendChild(wrap);
  }

  function buildDialog(title, content) {
    var dialog = $('.cm-sizechart__dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'cm-sizechart__dialog';
      /* tabindex=-1: macht den Dialog selbst programmatisch fokussierbar.
         Ohne das legt der Browser bei showModal() den Fokus automatisch auf
         das erste fokussierbare Element - hier den Close-Button - und der
         bekommt dadurch sofort seinen :focus-visible-Grauton samt der
         0.15s-Transition. Genau DAS war das "Schimmern" oben rechts direkt
         beim Oeffnen: ein Kreis, der in dem Moment von durchsichtig auf grau
         ueberblendet, in dem das Popup erscheint. Fokus geht jetzt stattdessen
         auf den Dialog selbst, der Button bleibt unberuehrt bis man ihn
         wirklich anklickt/antabbt. */
      dialog.tabIndex = -1;
      dialog.innerHTML =
        '<div class="cm-sizechart__inner">' +
        '<div class="cm-sizechart__head">' +
        '<h2 class="cm-sizechart__title"></h2>' +
        '</div><div class="cm-sizechart__body"></div>' +
        '<div class="cm-sizechart__scrolldown" aria-hidden="true"></div>' +
        '</div>' +
        '<button type="button" class="cm-sizechart__close" aria-label="Close">' +
        '<svg viewBox="0 0 16 16" class="cm-sizechart__close-icon" aria-hidden="true">' +
        '<path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg></button>';
      document.body.appendChild(dialog);

      dialog.querySelector('.cm-sizechart__close').addEventListener('click', function () {
        dialog.close();
      });

      /* Ein einziger Listener auf 'close' reicht fuer JEDEN Weg, wie das
         Popup zugeht - Close-Button, Klick auf den Backdrop (beides ruft
         dialog.close() auf) und die Escape-Taste (loest bei <dialog> nativ
         erst 'cancel', dann 'close' aus). So bleibt der Hintergrund nie
         versehentlich gesperrt, egal wie geschlossen wurde. */
      dialog.addEventListener('close', unlockBackgroundScroll);

      // Klick auf den Backdrop schliesst. Der Backdrop ist Teil des <dialog>,
      // deshalb wird geprueft, ob der Klick ausserhalb der Flaeche lag.
      dialog.addEventListener('click', function (e) {
        if (e.target !== dialog) return;
        var b = dialog.getBoundingClientRect();
        if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) {
          dialog.close();
        }
      });

      /* Mini-Scrollpfeil: zeigt/versteckt sich je nachdem, ob unterhalb
         noch etwas verborgen ist. */
      var dBody = dialog.querySelector('.cm-sizechart__body');
      var dArrow = dialog.querySelector('.cm-sizechart__scrolldown');
      function updateScrollArrow() {
        var hasMore = dBody.scrollHeight - dBody.scrollTop - dBody.clientHeight > 8;
        dArrow.classList.toggle('is-visible', hasMore);
      }
      dBody.addEventListener('scroll', updateScrollArrow);
      window.addEventListener('resize', updateScrollArrow);
      dialog._cmUpdateScrollArrow = updateScrollArrow;
    }

    dialog.querySelector('.cm-sizechart__title').textContent = title;
    var body = dialog.querySelector('.cm-sizechart__body');
    body.innerHTML = '';
    scrollUpdaters.length = 0;
    /* Bewusst die Kinder einhaengen, nicht die Sammel-Huelle: nur so sind
       Tabellen, Zwischenueberschriften und Hinweiszeilen direkte Kinder von
       .cm-sizechart__body - darauf bauen markNotes() und die Abstands-Regeln
       im CSS (N11) auf. */
    while (content.firstChild) body.appendChild(content.firstChild);

    markNotes(body);
    wrapHeaderCells(body);
    wrapTables(body);

    /* Passform-Grafik ganz unten. Sie wird IMMER gebaut - auch wenn in der
       Beschreibung kein Fit-Satz steht; dann greift der Normalfall
       "Fits true to size". */
    var noteText = $$('.cm-sg-note', body).map(function (n) {
      return n.textContent || '';
    }).join(' ');
    buildFitWidget(body, [noteText, fitSourceText], fitSeed);

    if (dialog._cmUpdateScrollArrow) {
      scrollUpdaters.push(dialog._cmUpdateScrollArrow);
    }

    return dialog;
  }

  /* Die Fade-Berechnung braucht echte Masse. Solange das Popup geschlossen
     ist, hat es keine - deshalb nach dem Oeffnen noch einmal nachrechnen. */
  function refreshOnOpen() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollUpdaters.forEach(function (fn) { fn(); });
      });
    });
    setTimeout(function () { scrollUpdaters.forEach(function (fn) { fn(); }); }, 150);
  }

  /* Denselben Abschnitt aus der sichtbaren Beschreibung entfernen, damit er
     nicht zusaetzlich unter dem Produkttext steht. Laeuft ueber ALLE
     Size-Abschnitte, nicht nur den ersten - sonst bliebe bei zwei Charts der
     zweite unten stehen. */
  function stripFromDescription() {
    var heads = $$(
      '.product-details .rte :is(h1,h2,h3,h4,h5,h6),' +
      '.product-details rte-formatter :is(h1,h2,h3,h4,h5,h6)'
    );
    heads.forEach(function (h) {
      if (!h.parentNode || !isTriggerText(text(h))) return;
      var rank = RANK[h.tagName];
      var doomed = [h];
      var next = h.nextElementSibling;
      while (next && !isBoundary(next, rank)) {
        doomed.push(next);
        next = next.nextElementSibling;
      }
      doomed.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    });
  }

  function init() {
    var sizeLabel = $('[data-cm-size] .cm-ws__label');

    // Nach einem Variantenwechsel wird die Auswahl neu gerendert - dann muss
    // der Ausloeser erneut angehaengt werden.
    if (built) {
      if (sizeLabel && !sizeLabel.querySelector('.cm-sizechart__trigger')) built = false;
      else return;
    }

    var src = $('[data-cm-sizeguide-src]');
    if (!src) return;

    var html;
    try { html = JSON.parse(src.textContent); } catch (e) { html = src.textContent; }
    if (!html) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = html;

    /* Fuer die Passform-Grafik: der gesamte Beschreibungstext als
       Rueckfallebene und eine stabile Produkt-ID als Streuwert. */
    fitSourceText = text(tmp);
    fitSeed = (window.__cmProduct && window.__cmProduct.id)
      || (document.querySelector('[data-product-id]')
          && document.querySelector('[data-product-id]').getAttribute('data-product-id'))
      || location.pathname;

    var data = collect(tmp);
    if (!data) {
      // Kein Size-Abschnitt in dieser Beschreibung -> kein Ausloeser.
      var stale = $('.cm-sizechart__trigger');
      if (stale) stale.remove();
      return;
    }

    // Wache 2: ohne Size-Auswahl auf der Seite kein Ausloeser.
    if (!sizeLabel) return;

    var dialog = buildDialog(data.title, data.frag);

    if (!sizeLabel.querySelector('.cm-sizechart__trigger')) {
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'cm-sizechart__trigger';
      // Symbol + Schriftzug. Die Unterstreichung sitzt bewusst nur auf dem
      // <span> — sonst liefe der Strich auch unter dem Icon durch.
      trigger.innerHTML = CM_SG_ICON + '<span class="cm-sizechart__trigger-label">Size chart</span>';
      trigger.addEventListener('click', function () {
        dialog.showModal();
        dialog.focus({ preventScroll: true });
        lockBackgroundScroll();
        refreshOnOpen();
      });
      sizeLabel.appendChild(trigger);
    }

    stripFromDescription();
    built = true;
  }

  /* =======================================================================
     PUBLIC ACCESSOR — lets other on-page widgets mirror this exact fit
     computation (same case detection, same seeded numbers) instead of
     running their own separate estimate. Read-only, no state changes.

     window.CMFit.getFitData(productId) returns:
       { case: 'true'|'oversized'|'down'|'small'|'leanup',
         head: '...', sub: '...',
         up: n, usual: n, down: n, total: n, pctTop: n }

     "up"/"down" mean "recommend sizing up/down", matching the row labels
     in this popup's own fit widget above.
  ===========================================================================*/
  window.CMFit = window.CMFit || {};
  window.CMFit.getFitData = function (productId) {
    var texts = [fitSourceText || ''];
    var fitCase = FIT_CASES['true'];
    for (var ti = 0; ti < texts.length; ti++) {
      var c = cmFitCase(texts[ti]);
      if (c.key !== 'true') { fitCase = c; break; }
    }
    var seed = fitSeed || productId || 'cm';
    if (window.RV_DEMO === false && !cmRealFit()) return null;
    var d = cmFitData(fitCase, seed);
    if (d.real) fitCase = cmRealCase(d, fitCase);
    var pctTop = Math.round((d[fitCase.top] / d.total) * 100);
    return {
      case: fitCase.key,
      head: fitCase.head,
      sub: fitCase.sub,
      up: d.up,
      usual: d.usual,
      down: d.down,
      total: d.total,
      pctTop: pctTop
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
  document.addEventListener('variant:change', init);

  /* Die eigene Variantenauswahl wird per JavaScript nachgereicht. Deshalb ein
     paar Nachlaeufe - sonst haengt der Ausloeser ins Leere, wenn das Label
     erst nach dem load-Event existiert. */
  [300, 800, 1500, 2500, 4000].forEach(function (ms) { setTimeout(init, ms); });

  var host = document.querySelector('.product-details') || document.body;
  if (host && window.MutationObserver) {
    /* Auf einen Frame gebuendelt: viele schnelle DOM-Aenderungen loesen nur
       EINEN Lauf aus. init() kehrt nach dem ersten Aufbau sofort zurueck. */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; init(); });
    }).observe(host, { childList: true, subtree: true });
  }
})();
